export const getLayoutKeyForMetaObjects = (layout) => {
    if (layout.includes('framed-canvas'))
        return 'framed-canvas';
    if (layout.includes('framed-print'))
        return 'framed-print';
    if (layout.includes('poster'))
        return 'poster-print';
    if (layout.includes('foam'))
        return 'foam';
    if (layout.includes('framed'))
        return 'framed';
    if (layout.includes('art-print'))
        return 'art-print';
    return 'canvas';
};
